module.exports = __webpack_public_path__ + "static/img/214_TO8_2158.ff41b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/214_TO8_2158.jpg
// module id = iooA
// module chunks = 0